import React from 'react';
import {
  Activity,
  AlertCircle,
  AlertTriangle,
  AlignLeft,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  AtSign,
  BadgePercent,
  BadgeCheck,
  BadgeIndianRupee,
  Ban,
  BarChart2,
  BarChart3,
  Bell,
  BellRing,
  BookOpen,
  BookOpenCheck,
  Bot,
  Braces,
  Briefcase,
  Building2,
  Calendar,
  CalendarClock,
  CalendarDays,
  Cable,
  Check,
  CheckCheck,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleDollarSign,
  CircleDot,
  CircleStop,
  Clock,
  CloudCog,
  Code2,
  Copy,
  CreditCard,
  Database,
  Download,
  Edit,
  ExternalLink,
  Eye,
  EyeOff,
  FileText,
  Filter,
  Fingerprint,
  FlaskConical,
  Gauge,
  Globe,
  Globe2,
  GraduationCap,
  GitBranch,
  Grid3X3,
  GripVertical,
  Hash,
  Handshake,
  Heading2,
  HelpCircle,
  History,
  Home,
  Inbox,
  Info,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  LayoutTemplate,
  LifeBuoy,
  Link,
  Lightbulb,
  Image,
  ListChecks,
  ListTodo,
  Loader,
  Loader2,
  Lock,
  LockKeyhole,
  LogOut,
  Mail,
  MailCheck,
  Map,
  MapPin,
  Megaphone,
  Menu,
  MessageCircle,
  MessageCircleQuestion,
  MessageCircleReply,
  MessageSquare,
  MessagesSquare,
  Minus,
  MinusCircle,
  MousePointerClick,
  Network,
  Package,
  PanelRightOpen,
  PanelTop,
  Paperclip,
  Pencil,
  PenLine,
  Phone,
  Plug,
  PlugZap,
  Plus,
  Pause,
  Power,
  Radar,
  RefreshCw,
  ReceiptText,
  Rocket,
  Route,
  Rows3,
  Quote,
  RotateCcw,
  RotateCw,
  Save,
  ScanSearch,
  ScanText,
  Search,
  SearchCheck,
  SearchX,
  SeparatorHorizontal,
  Send,
  Server,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldX,
  SlidersHorizontal,
  Sparkles,
  StickyNote,
  Tags,
  Target,
  TestTube,
  Timer,
  TimerReset,
  Trash2,
  TriangleAlert,
  TrendingDown,
  TrendingUp,
  Upload,
  UploadCloud,
  User,
  UserCheck,
  UserPlus,
  UserRound,
  UserRoundCheck,
  Users,
  Newspaper,
  Wand2,
  WandSparkles,
  Wallet,
  Workflow,
  Wrench,
  X,
  XCircle,
  Zap,
} from 'lucide-react';

const iconMap = {
  BriefcaseBusiness: Briefcase,
  Activity,
  AlertCircle,
  AlertTriangle,
  AlignLeft,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  AtSign,
  BadgePercent,
  BadgeCheck,
  BadgeIndianRupee,
  Ban,
  BarChart2,
  BarChart3,
  Bell,
  BellRing,
  BookOpen,
  BookOpenCheck,
  Bot,
  Braces,
  Briefcase,
  Building2,
  Calendar,
  CalendarClock,
  CalendarDays,
  Cable,
  Webhook: Cable,
  Check,
  CheckCheck,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleDollarSign,
  CircleDot,
  CircleStop,
  Clock,
  CloudCog,
  Code2,
  TerminalSquare: Code2,
  Copy,
  CreditCard,
  Database,
  Download,
  Edit,
  ExternalLink,
  Eye,
  EyeOff,
  FileText,
  Filter,
  Fingerprint,
  FlaskConical,
  Gauge,
  Globe,
  Globe2,
  GraduationCap,
  GitBranch,
  Grid3X3,
  GripVertical,
  Hash,
  Handshake,
  Heading2,
  HelpCircle,
  History,
  Home,
  Inbox,
  Info,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  LayoutTemplate,
  LifeBuoy,
  Link,
  Lightbulb,
  Image,
  ListChecks,
  ListTodo,
  Loader,
  Loader2,
  Lock,
  LockKeyhole,
  LogOut,
  Mail,
  MailCheck,
  Map,
  MapPin,
  Megaphone,
  Menu,
  MessageCircle,
  MessageCircleQuestion,
  MessageCircleReply,
  MessageSquare,
  MessagesSquare,
  Minus,
  MinusCircle,
  MousePointerClick,
  Network,
  Package,
  PanelRightOpen,
  PanelTop,
  Paperclip,
  Pencil,
  PenLine,
  Phone,
  PhoneCall: Phone,
  Plug,
  PlugZap,
  Plus,
  Pause,
  Power,
  Radar,
  RefreshCw,
  ReceiptText,
  Rocket,
  Route,
  Rows3,
  Quote,
  RotateCcw,
  RotateCw,
  Save,
  ScanSearch,
  ScanText,
  Search,
  SearchCheck,
  SearchX,
  SeparatorHorizontal,
  Send,
  Server,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldX,
  SlidersHorizontal,
  Sparkles,
  StickyNote,
  Tags,
  Target,
  TestTube,
  Timer,
  TimerReset,
  Trash2,
  TriangleAlert,
  TrendingDown,
  TrendingUp,
  Upload,
  UploadCloud,
  User,
  UserCheck,
  UserPlus,
  UserRound,
  UserRoundCheck,
  Users,
  UsersRound: Users,
  Newspaper,
  Wand2,
  WandSparkles,
  Wallet,
  Workflow,
  Wrench,
  X,
  XCircle,
  Zap,
};

function Icon({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  strokeWidth = 2,
  ...props
}) {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
}

export default Icon;
